import type {
  ShareLinkView,
  ShareMode,
  ShareStats,
  SharedAccessResponse,
} from '@/contracts/sharing';
import { apiDelete, apiGet, apiPatch, apiPost } from '@/infrastructure/api-client';

export const getShare = (funnelId: string) =>
  apiGet<{ share: ShareLinkView | null }>(`/api/funnels/${funnelId}/share`);
export const saveShare = (
  funnelId: string,
  input: { mode: ShareMode; password?: string; enabled?: boolean },
  exists: boolean,
) =>
  exists
    ? apiPatch<{ share: ShareLinkView }>(`/api/funnels/${funnelId}/share`, input)
    : apiPost<{ share: ShareLinkView }>(`/api/funnels/${funnelId}/share`, input);
export const regenerateShare = (funnelId: string) =>
  apiPost<{ share: ShareLinkView }>(`/api/funnels/${funnelId}/share/regenerate`, {});
export const disableShare = (funnelId: string) =>
  apiDelete<{ ok: true }>(`/api/funnels/${funnelId}/share`);
export const getShareStats = (funnelId: string) =>
  apiGet<{ stats: ShareStats }>(`/api/funnels/${funnelId}/share/stats`);
export const getSharedView = (token: string) =>
  apiGet<SharedAccessResponse>(`/api/shared/${encodeURIComponent(token)}`);
export const unlockSharedView = (token: string, password: string) =>
  apiPost<{ ok: true }>(`/api/shared/${encodeURIComponent(token)}/password`, { password });
